import React, { useState } from 'react';
import { Menu, Phone, X } from 'lucide-react';
import { Button } from './Button';
const navigation = [{
  label: 'Our approach',
  href: '#approach'
}, {
  label: 'Services',
  href: '#services'
}, {
  label: 'Projects',
  href: '#projects'
}, {
  label: 'Process',
  href: '#process'
}];
export function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  function closeMenu() {
    setMenuOpen(false);
  }
  return <header className="sticky top-0 z-50 border-b border-white/10 bg-[#123b35]/95 text-white backdrop-blur" data-id="element-141">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 sm:px-8" data-id="element-142">
        <a href="#top" className="group flex items-center gap-3" aria-label="Natural Swimming Pools home" data-id="element-143">
          <span className="flex h-10 w-10 items-center justify-center rounded-full border border-[#75c4cf] text-xl font-semibold text-[#8de0e5]" data-id="element-144">
            N
          </span>
          <span className="leading-none" data-id="element-145">
            <span className="block text-base font-semibold tracking-tight" data-id="element-146">
              Natural
            </span>
            <span className="block pt-1 text-[10px] font-medium uppercase tracking-[0.2em] text-[#a7c7bd]" data-id="element-147">
              Swimming Pools
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary navigation" data-id="element-148">
          {navigation.map(item => <a key={item.href} href={item.href} className="text-sm text-[#d5e4dc] transition hover:text-white" data-id="element-149">
              {item.label}
            </a>)}
        </nav>

        <div className="hidden items-center gap-4 lg:flex" data-id="element-150">
          <a href="tel:+16025656313" className="flex items-center gap-2 text-sm font-medium text-[#d5e4dc] hover:text-white" data-id="element-151">
            <Phone size={15} aria-hidden="true" data-id="element-152" />
            (602) 565-6313
          </a>
          <Button asChild className="h-10 rounded-full bg-[#8de0e5] px-5 text-[#123b35] hover:bg-white" data-id="element-153">
            <a href="#consultation" data-id="element-154">Start a project</a>
          </Button>
        </div>

        <button type="button" className="rounded-md p-2 text-white focus-visible:ring-2 focus-visible:ring-[#8de0e5] lg:hidden" aria-label={menuOpen ? 'Close menu' : 'Open menu'} aria-expanded={menuOpen} onClick={() => setMenuOpen(!menuOpen)} data-id="element-155">
          {menuOpen ? <X size={23} data-id="element-156" /> : <Menu size={23} data-id="element-157" />}
        </button>
      </div>

      {menuOpen && <nav className="border-t border-white/10 bg-[#123b35] px-5 py-5 lg:hidden" aria-label="Mobile navigation" data-id="element-158">
          <div className="mx-auto flex max-w-7xl flex-col gap-1" data-id="element-159">
            {navigation.map(item => <a key={item.href} href={item.href} onClick={closeMenu} className="rounded-lg px-3 py-3 text-base text-white hover:bg-white/10" data-id="element-160">
                {item.label}
              </a>)}
            <a href="tel:+16025656313" onClick={closeMenu} className="mt-2 flex items-center gap-2 rounded-lg px-3 py-3 text-sm text-[#d5e4dc]" data-id="element-161">
              <Phone size={16} aria-hidden="true" data-id="element-162" />
              (602) 565-6313
            </a>
            <a href="#consultation" onClick={closeMenu} className="mt-2 rounded-full bg-[#8de0e5] px-5 py-3 text-center text-sm font-semibold text-[#123b35]" data-id="element-163">
              Start your pool project
            </a>
          </div>
        </nav>}
    </header>;
}